import {
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
  ShadingType,
  AlignmentType,
  VerticalAlign,
} from "docx";

const labelTranslations = {
  TV: "TELEVIZIONE",
  RADIO: "Radiot",
  CABLE: "Kabllorët",
  OTHER: "Shërbimet e tjera",
};

export function ModelWordListOshma(data) {
  const docSections = [];
  const grouped = {};

  for (const entry of data) {
    if (!grouped[entry.type]) {
      grouped[entry.type] = [];
    }
    grouped[entry.type].push(entry);
  }

  for (const type in grouped) {
    const entries = grouped[type];

    const labelTitle = new Paragraph({
      children: [
        // Katrori i kuq
        new TextRun({
          text: "       ", // më shumë hapësirë
          shading: {
            type: ShadingType.CLEAR,
            fill: "ED1D25", // ngjyra e kuqe
            color: "auto",
          },
          size: 18, // më e madhe për të dukur si katror
          bold: true,
        }),

        // Pak hapësirë ndërmjet
        new TextRun({
          text: "  ", // hapësirë mes katrorit dhe tekstit
        }),

        // Teksti
        new TextRun({
          text: `${labelTranslations[type]}`,
          color: "ED1D25", // ngjyra e tekstit (p.sh. kuqe)
          font: "Arial", // fonti që dëshiron
          size: 32, // madhësia në 1/2 piksel (kjo do 16pt)
        }),
      ],
    });

    // Rreshti 1: EMRI I SUBJEKTIT me rowSpan: 2, dhe KONTAKTE në 3 qeliza
    const headerRow1 = new TableRow({
      marginTop: 300,
      children: [
        new TableCell({
          rowSpan: 2,
          margins: {
            top: 30, // në twips (1/20 i pikës, 100 = 5pt)
            bottom: 30,
            left: 40, // 200 = 10pt
            right: 40,
          },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "EMRI I SUBJEKTIT (OSHMA)",
                  bold: true,
                  color: "FFFFFF",
                  size: 24,
                }),
              ],
              alignment: "center",
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: {
            type: ShadingType.CLEAR,
            color: "auto",
            fill: "ED1D25",
          },
          width: { size: 15, type: WidthType.PERCENTAGE },
        }),
        new TableCell({
          columnSpan: 3,
          margins: {
            top: 30, // në twips (1/20 i pikës, 100 = 5pt)
            bottom: 30,
            left: 40, // 200 = 10pt
            right: 40,
          },
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "KONTAKTE",
                  bold: true,
                  color: "FFFFFF",
                  size: 24,
                }),
              ],
              alignment: "center",
            }),
          ],
          shading: {
            type: ShadingType.CLEAR,
            color: "auto",
            fill: "ED1D25",
          },
          verticalAlign: VerticalAlign.CENTER,
          width: { size: 85, type: WidthType.PERCENTAGE },
        }),
      ],
    });

    // Rreshti 2: etiketat e kolonave KONTAKTE
    const headerRow2 = new TableRow({
      children: ["ADRESA", "TELEFONI", "E-MAIL"].map(
        (label) =>
          new TableCell({
            margins: {
              top: 30, // në twips (1/20 i pikës, 100 = 5pt)
              bottom: 30,
              left: 40, // 200 = 10pt
              right: 40,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: label,
                    bold: true,
                    color: "FFFFFF",
                    size: 24,
                  }),
                ],
                alignment: "center",
              }),
            ],
            shading: {
              type: ShadingType.CLEAR,
              color: "auto",
              fill: "ED1D25",
            },
            verticalAlign: VerticalAlign.CENTER,
            width: {
              size: label === "TELEFONI" ? 20 : 35,
              type: WidthType.PERCENTAGE,
            },
          })
      ),
    });

    // Të dhënat
    const dataRows = entries.map(
      (entry) =>
        new TableRow({
          children: [
            new TableCell({
              margins: {
                top: 30, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 30,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: entry.name || "",
                      size: 20,
                    }),
                  ],
                  alignment: "center",
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
              width: { size: 15, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              margins: {
                top: 30, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 30,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: entry.address || "",
                      size: 20,
                    }),
                  ],
                  alignment: "center",
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
              width: { size: 35, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              margins: {
                top: 30, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 30,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: entry.phoneNumber || "",
                      size: 20,
                    }),
                  ],
                  alignment: "center",
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
              width: { size: 20, type: WidthType.PERCENTAGE },
            }),
            new TableCell({
              margins: {
                top: 30, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 30,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: entry.email || "",
                      size: 20,
                    }),
                  ],
                  alignment: "left",
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
              width: { size: 30, type: WidthType.PERCENTAGE },
            }),
          ],
        })
    );

    const table = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [headerRow1, headerRow2, ...dataRows],
    });

    docSections.push(
      labelTitle,
      new Paragraph({
        text: "", // paragraf bosh
        spacing: { after: 50 },
      }),
      table,
      new Paragraph({
        text: "", // paragraf bosh
        spacing: { after: 200 },
      })
    );
  }

  return docSections;
}
